import { NewdanhmucsanphamService } from 'src/services/newdanhmucsanpham.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCSANPHAM_NEW_CARE_SUCCESS = 'NEWDANHMUCSANPHAM:NEW_CARE_SUCCESS'
export const NEWDANHMUCSANPHAM_LIST_SUCCESS = 'NEWDANHMUCSANPHAM:FIND_ALL_SUCCESS'
export const NEWDANHMUCSANPHAM_LIST_FAILD = 'NEWDANHMUCSANPHAM:FIND_ALL_FAILD'
export const NEWDANHMUCSANPHAM_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCSANPHAM:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCSANPHAM_COUNT_ASSIGN_FAILD = 'NEWDANHMUCSANPHAM:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCSANPHAM_CREATE_SUCCESS = 'NEWDANHMUCSANPHAM:CREATE_SUCCESS'
export const NEWDANHMUCSANPHAM_CREATE_FAILD = 'NEWDANHMUCSANPHAM:CREATE_FAILD'

export const NEWDANHMUCSANPHAM_IMPORT_SUCCESS = 'NEWDANHMUCSANPHAM:IMPORT_SUCCESS'
export const NEWDANHMUCSANPHAM_SAVE_SUCCESS = 'NEWDANHMUCSANPHAM:SAVE_SUCCESS'
export const NEWDANHMUCSANPHAM_SAVE_FAILD = 'NEWDANHMUCSANPHAM:SAVE_SUCCESS'

export const NEWDANHMUCSANPHAM_DEL_SUCCESS = 'NEWDANHMUCSANPHAM:DEL_SUCCESS'
export const NEWDANHMUCSANPHAM_DEL_FAILD = 'NEWDANHMUCSANPHAM:DEL_FAILD'

export const NEWDANHMUCSANPHAM_ONE_SUCCESS = 'NEWDANHMUCSANPHAM:FIND_ONE_SUCCESS'
export const NEWDANHMUCSANPHAM_ONE_FAILD = 'NEWDANHMUCSANPHAM:FIND_ONE_FAILD'

export const NEWDANHMUCSANPHAM_HISTORY_LIST_SUCCESS = 'NEWDANHMUCSANPHAM:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCSANPHAM_HISTORY_LIST_FAILD = 'NEWDANHMUCSANPHAM:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCSANPHAM_UPDATE_FILTER = 'NEWDANHMUCSANPHAM:NEWDANHMUCSANPHAM_UPDATE_FILTER'

export const NEWDANHMUCSANPHAM_LIST_EXPORT_SUCCESS = 'NEWDANHMUCSANPHAM:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCSANPHAM_LIST_EXPORT_FAILD = 'NEWDANHMUCSANPHAM:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCSANPHAM_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCSANPHAM:NEWDANHMUCSANPHAM_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCSANPHAM_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCSANPHAM:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCSANPHAM_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCSANPHAM:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCSANPHAM_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCSANPHAM:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCSANPHAM_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCSANPHAM:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCSANPHAM_ORDER_SUCCESS = 'NEWDANHMUCSANPHAM:ORDER_SUCCESS'
export const NEWDANHMUCSANPHAM_ORDER_FAILD = 'NEWDANHMUCSANPHAM:ORDER_FAILD'

export const NEWDANHMUCSANPHAM_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCSANPHAM:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCSANPHAM_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCSANPHAM:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCSANPHAM_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCSANPHAM:NEWDANHMUCSANPHAM_HANDLE_IMPORT_ERRORS'

export const NewdanhmucsanphamAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    sanphamList,
}

function sanphamList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucsanphamService.sanphamList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucsanphamService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCSANPHAM_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucsanpham } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucsanphamFilter } = newdanhmucsanpham;
        const homepageNewdanhmucsanphamPage = homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamPage;
        const homepageNewdanhmucsanphamLimit = homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucsanphamService.homepageList(homepageNewdanhmucsanphamFilter).then((rs) => {
                if (!!homepageNewdanhmucsanphamFilter && homepageNewdanhmucsanphamFilter.homepageNewdanhmucsanphamPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucsanphamItems: rs.data.values,
                        homepageNewdanhmucsanphamTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucsanpham.homepageNewdanhmucsanphamItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucsanphamLimit * homepageNewdanhmucsanphamPage; i < homepageNewdanhmucsanphamLimit * homepageNewdanhmucsanphamPage + homepageNewdanhmucsanphamLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucsanphamLimit * homepageNewdanhmucsanphamPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucsanphamLimit * homepageNewdanhmucsanphamPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucsanphamItems: uniqueItems,
                        homepageNewdanhmucsanphamTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCSANPHAM_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucsanphamService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucsanpham } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucsanpham.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucsanphamService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucsanphamAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCSANPHAM_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCSANPHAM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucsanphamService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucsanpham } = getState();

            const { filter } = newdanhmucsanpham;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucsanphamService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCSANPHAM_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucsanpham } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucsanpham;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucsanphamService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucsanpham.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCSANPHAM_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucsanphamService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucsanphamAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCSANPHAM_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucsanphamAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucsanphamAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucsanphamAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucsanphamAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucsanpham } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucsanpham.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucsanphamService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCSANPHAM_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCSANPHAM_ORDER_FAILD, error } }
}